module.exports = __webpack_public_path__ + "img/Monte_Kope_22.f1b87455.jpg";